import React, { FC } from "react";
import { ExamDayType } from "../../../model/ExamDayType";
import SchedulerContextProvider from "../context/SchedulerContextProvider";
import Scheduler from "../Scheduler";

const OralExamsScheduler: FC = () => (
  <SchedulerContextProvider examDayType={ExamDayType.Oral}>
    <Scheduler />
  </SchedulerContextProvider>
);

export default OralExamsScheduler;
